import { render, staticRenderFns } from "./Modelli.vue?vue&type=template&id=60926824&"
import script from "./Modelli.vue?vue&type=script&lang=js&"
export * from "./Modelli.vue?vue&type=script&lang=js&"
import style0 from "./Modelli.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports